/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import FormGroup from './form/FormGroup';
import PublicVisibilityToggle from './form/PublicVisibilityToggle';
import { validateFormIntro } from '../../config/schemas/schemas-forms';
import ErrorField from './form/ErrorField';
import { useGetUserProfile } from '../../hooks/api/useUserProfile';
import { useSelector } from 'react-redux';
import images from '../../assets/images';
import Button from '../../components/button/Button';
import styles from './customLoading.module.css';
import { useGetOrganizationMetadata } from '../../hooks/api/useOrganization';

const FormEditIntro = ({
    handleSubmit,
    setResumeFile,
    isUploadingAndSaving,
    btnText
}) => {
    const { data, isLoading: isGetLoading } = useGetUserProfile();
    const {
        idOrganization,
        user: { email }
    } = useSelector(state => state.auth);

    console.log('alberthdata', data);

    const formIntroSchema = validateFormIntro();

    const {
        data: organizationMetadata,
        isLoading: isGetOrganizationMetadataLoading
    } = useGetOrganizationMetadata(idOrganization);

    if (isGetLoading || isGetOrganizationMetadataLoading) {
        return (
            <div className={styles.loadingMain}>
                <img src={images.Spinner} alt="loading" />
            </div>
        );
    }
    const transformedData = {
        name: data.name,
        lastname: data.lastname,
        country: data.country,
        city: data.city,
        state: data.state,
        segment: data.segment,
        title: data.title,
        company: data.company,
        companyDepartment: data.companyDepartment,
        email: data.email,
        phone: data.phone,
        resume: data.resume,
        linkedIn: data.linkedIn,
        boardDirectors: data.boardDirectors ? '1' : '0',
        vendorOffers: data.vendorOffers ? '1' : '0',
        privateEmail: data.privateEmail ? '1' : '0',
        privatePhone: data.privatePhone ? '1' : '0'
    };

    return (
        <div className="formain">
            <div className="formain__title">
                <h1>Edit Intro</h1>
            </div>
            <h3 className="formain__text">* Indicates required field</h3>

            <Formik
                enableReinitialize={true}
                initialValues={transformedData}
                validationSchema={formIntroSchema}
                onSubmit={val => {
                    handleSubmit(val);
                }}>
                {({
                    errors,
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue
                }) => (
                    <Form>
                        <FormGroup
                            label="First Name (cannot be changed)"
                            id="name">
                            <Field
                                type="text"
                                placeholder="First Name"
                                name="name"
                                id="name"
                                disabled
                            />
                        </FormGroup>
                        <FormGroup
                            label="Last Name (cannot be changed)"
                            id="lastname"
                            type="text">
                            <Field
                                type="text"
                                placeholder="Last Name"
                                name="lastname"
                                id="lastname"
                                disabled
                            />
                        </FormGroup>

                        <FormGroup
                            label="Are you on the Board of Directors?"
                            id="boardDirectors"
                            type="radio">
                            <Field
                                type="radio"
                                id="yes"
                                name="boardDirectors"
                                className="cradio"
                                value="1"
                                checked={
                                    values.boardDirectors === '1' ||
                                    values.boardDirectors === true
                                }
                            />
                            <label htmlFor="yes">Yes</label>
                            <Field
                                type="radio"
                                id="no"
                                name="boardDirectors"
                                className="cradio"
                                value="0"
                                checked={
                                    values.boardDirectors === '0' ||
                                    values.boardDirectors === false
                                }
                            />
                            <label htmlFor="no">No</label>
                        </FormGroup>
                        <FormGroup
                            label="Are you looking for Vendor Offers?"
                            id="vendorOffers"
                            type="radio">
                            <Field
                                type="radio"
                                id="yes2"
                                name="vendorOffers"
                                className="cradio"
                                value="1"
                                checked={
                                    values.vendorOffers === '1' ||
                                    values.vendorOffers === true
                                }
                            />
                            <label htmlFor="yes2">Yes</label>
                            <Field
                                type="radio"
                                id="no2"
                                name="vendorOffers"
                                className="cradio"
                                value="0"
                                checked={
                                    values.vendorOffers === '0' ||
                                    values.vendorOffers === false
                                }
                            />
                            <label htmlFor="no2">No</label>
                        </FormGroup>

                        <FormGroup
                            id="country"
                            myclass="column-2"
                            label="Country">
                            <CountryDropdown
                                valueType="short"
                                value={values.country}
                                name="country"
                                onChange={(_, e) => {
                                    handleChange(e);
                                    setFieldValue('state', '');
                                    setFieldValue(
                                        'CountryName',
                                        // nameCountry[0][0]
                                        e.target.options[e.target.selectedIndex]
                                            .text
                                    );
                                }}
                                onBlur={handleBlur}></CountryDropdown>
                        </FormGroup>

                        <div className="column-2">
                            <FormGroup id="city" label="City">
                                <Field
                                    id="city"
                                    type="text"
                                    name="city"
                                    placeholder="City"
                                />
                                {values.country === 'US' && (
                                    <ErrorMessage
                                        name="city"
                                        component={() => (
                                            <ErrorField>
                                                {errors.city}
                                            </ErrorField>
                                        )}
                                    />
                                )}
                            </FormGroup>
                            <FormGroup id="state" label="State">
                                <RegionDropdown
                                    valueType="short"
                                    countryValueType="short"
                                    country={values.country}
                                    value={values.state}
                                    name="state"
                                    onChange={(_, e) => handleChange(e)}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            <ErrorMessage
                                name="state"
                                component={() => (
                                    <ErrorField>{errors.state}</ErrorField>
                                )}
                            />
                            {/* is commented on for testing but will be used at a later date */}
                            {/* {values.country === 'US' && (
                                <ErrorMessage
                                    name="state"
                                    component={() => (
                                        <ErrorField>{errors.state}</ErrorField>
                                    )}
                                />
                            )} */}
                        </div>
                        <FormGroup label="Segment *" id="segment">
                            <Field
                                id="segment"
                                type="text"
                                name="segment"
                                placeholder="Segment"
                                disabled
                            />
                            <ErrorMessage
                                name="segment"
                                component={() => (
                                    <ErrorField>{errors.segment}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Title *" id="title">
                            <Field
                                id="title"
                                type="text"
                                name="title"
                                placeholder="Social Media Manager"
                            />
                            <ErrorMessage
                                name="title"
                                component={() => (
                                    <ErrorField>{errors.title}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Company *" id="company">
                            <Field
                                id="company"
                                type="text"
                                name="company"
                                placeholder="Outdoors International"
                            />
                            <ErrorMessage
                                name="company"
                                component={() => (
                                    <ErrorField>{errors.company}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <FormGroup label="Department *" id="companyDepartment">
                            <Field as="select" name="companyDepartment">
                                {/* <option value="Marketing">Marketing</option>
                                <option value="Marketing_2">Marketing 2</option>
                                <option value="Marketing_3">Marketing 3</option> */}
                                {organizationMetadata[
                                    'company-department'
                                ]?.options?.map(market => (
                                    <option
                                        key={market.id}
                                        value={market.value}>
                                        {market.value}
                                    </option>
                                ))}
                            </Field>
                            <ErrorMessage
                                name="companyDepartment"
                                component={() => (
                                    <ErrorField>
                                        {errors.companyDepartment}
                                    </ErrorField>
                                )}
                            />
                        </FormGroup>

                        <PublicVisibilityToggle
                            label="Email"
                            groupName="email"
                            value={values.privateEmail}
                            visibilityFieldName="privateEmail">
                            <Field
                                id="email"
                                type="email"
                                name="email"
                                value={email}
                                disabled
                            />
                        </PublicVisibilityToggle>

                        <PublicVisibilityToggle
                            label="Phone"
                            groupName="phone"
                            value={values.privatePhone}
                            visibilityFieldName="privatePhone">
                            <Field id="phone" type="text" name="phone" />
                            <ErrorMessage
                                name="phone"
                                component={() => (
                                    <ErrorField>{errors.phone}</ErrorField>
                                )}
                            />
                        </PublicVisibilityToggle>

                        <div className="grid-file">
                            <div className="form-input ">
                                <label htmlFor="resume">Resume</label>
                                <input
                                    id="resume"
                                    type="file"
                                    onChange={e =>
                                        setResumeFile(e.target.files[0])
                                    }
                                />
                            </div>
                            <button
                                type="button"
                                title="Remove file"
                                className="remove-file">
                                X
                            </button>
                        </div>

                        <FormGroup label="linkedIn" id="linkedIn">
                            <Field
                                type="text"
                                placeholder="https://www.linkedin.com/in/User1234"
                                name="linkedIn"
                                id="linkedIn"
                            />
                            <ErrorMessage
                                name="linkedIn"
                                component={() => (
                                    <ErrorField>{errors.linkedIn}</ErrorField>
                                )}
                            />
                        </FormGroup>
                        <div className="text-right">
                            <ErrorMessage
                                component={() => (
                                    <ErrorField>
                                        {Object.values(errors)[0]}
                                    </ErrorField>
                                )}
                            />
                            <Button
                                spinner={
                                    isUploadingAndSaving && images.Spinner3
                                }
                                loading={isUploadingAndSaving}
                                text={btnText || 'Save'}
                                classs="btnMain"
                                type="submit"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

FormEditIntro.propTypes = {
    onChange: PropTypes.func,
    closeModalEditIntro: PropTypes.func,
    openModalAlertSuccess1: PropTypes.func
};

export default FormEditIntro;
